module.exports = __webpack_public_path__ + "static/media/Wool.15c2e11a.svg";